import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledReadMoreComponent } from "./read-more-component.scss";
class ReadMoreComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledReadMoreComponent, {
            className: "read-more-component",
            children: "Read More >"
        });
    }
}
export { ReadMoreComponent as default };
